import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import ModalInvoicePayment from './ModalInvoicePayment';
import InvoiceView from './InvoiceView';


@inject('userStore')
class ModalInvoiceList extends Component {
    constructor(props){
        super(props);
        this.state = {
            invoice_list:null,
            invoice_type_list:[],
            selectedInvoice:null,
            viewInvoice:null
        }
        this.getInvoiceList = this.getInvoiceList.bind(this);
        this.publishedOnChange = this.publishedOnChange.bind(this);
        this.sendPaymentRequest = this.sendPaymentRequest.bind(this);
        this.reloadHandler = this.reloadHandler.bind(this);
    }

    componentDidMount(){
        this.getInvoiceList();
    }

    setInvoice(invoice){
        this.setState({
            selectedInvoice:invoice,
            viewInvoice:null
        })
    }

    setViewInvoice = (invoice) => {
      console.log(invoice);
      this.setState({
        viewInvoice:invoice,
        selectedInvoice:null
      })
    }

    reloadHandler(updated_invoice){
        let temp_invoice_list = this.state.invoice_list;
        let index = this.state.invoice_list.findIndex(x => x.id === updated_invoice.id);
        temp_invoice_list[index] = updated_invoice;
        this.setState({
            invoice_list:temp_invoice_list
        }, ()=>console.log(this.state.invoice_list))
    }

    publishedOnChange(event, invoice){
        if (event.target.checked){
            invoice.is_published = 1;
        } else {
            invoice.is_published = 0;
        }
        // save this
        post('v2/save/invoice_publish', {
                invoice_hash_id: invoice.hash_id,
                is_published: invoice.is_published
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              console.log(res.data);
              this.forceUpdate();
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }


    statusOnChange(event, invoice){
        if (event.target.checked){
            invoice.sys_status_id = 1;
        } else {
            invoice.sys_status_id = 2;
        }
        // save this
        post('v2/save/invoice_status', {
                invoice_hash_id: invoice.hash_id,
                sys_status_id: invoice.sys_status_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              this.forceUpdate();
              alert(res.data.message);
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }

    sendPaymentRequest(invoice){
        post('/v2/send/payment_request', {hash_id: invoice.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                this.props.notifyHandler.show(res.data.message, "success", 1000);
            } else {
                this.props.notifyHandler.show(res.data.message, "danger", 1000);
            }
        }).catch((error) => {
            this.props.notifyHandler.show(error, "danger", 1000);
            console.log(error);
            return error;
        });
    }

    getInvoiceList(){
        post('v2/get/invoice_list', {
                booking_hash_id: this.props.inquiry.hash_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              console.log(res.data);
              this.setState({
                  invoice_list:res.data.invoice_list,
                  invoice_type_list:res.data.invoice_type_list,
                  payment_type_list:res.data.payment_type_list
              })
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }

  render() {
      if (!this.props.inquiry) return <div className="alert alert-danger">No Booking Loaded</div>;
      const {invoiceHandler, createInvoiceHandler, notifyHandler} = this.props;
      const {viewInvoice, selectedInvoice, payment_type_list, payment} = this.state;
      const CheckBox = props => {
          const checked = props.is_published === 1 ? "checked" : null;
          return <input {...props} checked={checked}/>
      };
      const StatusCheckBox = props => {
          const checked = props.sys_status_id === 1 ? "checked" : null;
          return <input {...props} checked={checked}/>
      };

    return (
    	<React.Fragment>
            {selectedInvoice ?
                <ModalInvoicePayment invoice={selectedInvoice} payment_type_list={payment_type_list} reloadHandler={this.reloadHandler} notifyHandler={notifyHandler} modalBackgroundClicked={()=>this.setState({selectedInvoice:null})}/>
            :
            viewInvoice ?
                <InvoiceView invoice={viewInvoice} modalBackgroundClicked={()=>this.setState({viewInvoice:null})}/>
            :
            <React.Fragment>
                <div className="pull-right btn-group btn-success mb-20">
                    <button className="btn btn-primary dropdown-toggle" data-toggle="dropdown">Create Invoice</button>
                    <div className="dropdown-menu">
                    {this.state.invoice_type_list.map((invoice_type, index) =>
                        <a className="dropdown-item" key={index} onClick={(event)=>createInvoiceHandler(this.props.inquiry, invoice_type.id)}>{invoice_type.name}</a>
                    )}
                    </div>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th width="0%" align="center">#</th>
                            <th width="35%">Description</th>
                            <th width="15%">Due</th>
                            <th width="10%">Paid?</th>
                            <th width="10%">Published?</th>
                            <th width="10%">Accounted?</th>
                            <th width="20%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                {this.state.invoice_list ? this.state.invoice_list.length === 0 ? <div className="media media-single"><span className="badge badge-success">No Invoices</span></div> : this.state.invoice_list.map((invoice, invoice_index)=>{
                    return (
                        <tr key={invoice_index}>
                            <td>{invoice.id}</td>
                            <td>{invoice.description}</td>
                            <td>${invoice.due_amount}</td>
                            <td align="center">{invoice.is_paid ? <span className="badge badge-success">YES</span> : <span className="badge badge-danger">NO</span>}</td>
                            <td align="center">
                                <label className="switch switch-lg">
                                    <CheckBox type="checkbox" is_published={invoice.is_published} onChange={(event) => this.publishedOnChange(event, invoice)}/>
                                    <span className="switch-indicator"></span>
                                </label>
                            </td>
                            <td align="center">
                                <label className="switch switch-lg">
                                    <StatusCheckBox type="checkbox" sys_status_id={invoice.sys_status_id} onChange={(event) => this.statusOnChange(event, invoice)}/>
                                    <span className="switch-indicator"></span>
                                </label>
                            </td>
                            <td align="center"><div className="btn-group-vertical">
                                <button className="btn btn-block btn-secondary btn-xs" onClick={()=>this.setViewInvoice(invoice)}><i className="fa-fw fa fa-search"></i> View</button>
                                {invoice.is_published === 0 ? <button className="btn btn-block btn-primary btn-xs" onClick={()=>invoiceHandler(invoice, this.props.inquiry)}><i className="fa-fw fa fa-pencil"></i> Edit</button> : null}
                                {!invoice.is_paid ? <button className="btn btn-block btn-success btn-xs" onClick={() => this.setInvoice(invoice)}><i className="fa-fw fa fa-money"></i> Record Payment</button> : null}
                                <button className="btn btn-block btn-info btn-xs" onClick={()=>this.sendPaymentRequest(invoice)}><i className="fa fa-fw fa-envelope"></i> Send Request</button>
                            </div></td>
                        </tr>
                    );
                }) : <tr><td colSpan="6">Loading... Please Wait.</td></tr>}
                    </tbody>
                </table>
            </React.Fragment>
        }
        </React.Fragment>
    )
  }
}

export default ModalInvoiceList;



// WEBPACK FOOTER //
// ./src/components/business/ModalInvoiceList.js